import { render, staticRenderFns } from "./PracticeHint.vue?vue&type=template&id=a4f8bab6&scoped=true&"
import script from "./PracticeHint.vue?vue&type=script&lang=js&"
export * from "./PracticeHint.vue?vue&type=script&lang=js&"
import style0 from "./PracticeHint.vue?vue&type=style&index=0&id=a4f8bab6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f8bab6",
  null
  
)

export default component.exports